import {State, Module} from '../decorators.js';

import HomepageStore from '../stores/homepage';

import BaseRoute from '../routing';
import template from './main.html';

class Ctrl {
    constructor($stats) {
        "ngInject";
        this.stats = $stats;
    }
}

@Module({
    name: 'app.home',
    modules: [
        BaseRoute, HomepageStore
    ],
})
@State({
    name: 'r.in.top.home',
    url: '/',
    controller: Ctrl,
    template: template,
    ncyBreadcrumb: {
        skip: true,
    },
    resolve: {
        $stats: function (HomepageStore) {
            return HomepageStore.get();
        }
    }
})
export default class States {
}



// WEBPACK FOOTER //
// ./src/app/home/routing.js